import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import HRDashboard from './dashboards/HRDashboard';
import ManagerDashboard from './dashboards/ManagerDashboard';
import EmployeeDashboard from './dashboards/EmployeeDashboard';

/**
 * EPRDashboard — thin router that picks the dashboard variant by role.
 *
 * HR (superadmin/admin/hr_admin) → HRDashboard
 *   Cycle funnel, at-risk reviews, quick actions, distribution, recent activity.
 *
 * Manager / Leader → ManagerDashboard
 *   My to-do (manager review forms + magic-link invites), direct reports
 *   list with status, own self-review summary.
 *
 * Employee (default) → EmployeeDashboard
 *   Where-am-I stepper, self-review CTA, anonymous reviewer panel summary.
 *
 * Anonymous magic-link reviewers never reach this page — they go to
 * /r/:token directly without authentication.
 */
const EPRDashboard: React.FC = () => {
  const { user } = useAuth();
  if (!user) return <div className="p-8 text-stone-500 text-sm">Loading…</div>;

  const role = user.role ?? 'employee';
  const isHR      = ['superadmin', 'admin', 'hr_admin'].includes(role);
  const isManager = !isHR && (role === 'leader' || Boolean(user.isLeader));

  if (isHR)      return <HRDashboard />;
  if (isManager) return <ManagerDashboard />;
  return <EmployeeDashboard />;
};

export default EPRDashboard;
